import React from 'react'

type Props = {
  term: string
  definition: string
  className?: string
  /** Rótulo traduzido «Definição» (namespace «Blocks»). */
  labelText?: string
  /** Template aria com {term} (namespace «Blocks»). */
  ariaTemplate?: string
}

/**
 * Destaque semântico para AEO (definição explícita no fluxo de leitura).
 */
export function DefinitionBlock({ term, definition, className, labelText = 'Definição', ariaTemplate }: Props) {
  const t = term?.trim() ?? ''
  const d = definition?.trim() ?? ''
  if (!t || !d) return null

  return (
    <aside
      className={[
        'definition-block col-start-2 my-6 rounded-lg border border-border/80 bg-muted/30 px-4 py-3 md:px-5 md:py-4',
        className ?? '',
      ]
        .filter(Boolean)
        .join(' ')}
      data-block-type="definition"
      aria-label={ariaTemplate ? ariaTemplate.replace('{term}', t) : `Definição: ${t}`}
    >
      <p className="text-muted-foreground m-0 text-xs font-medium uppercase tracking-wide">{labelText}</p>
      <p className="text-foreground mt-1 mb-2 text-lg font-semibold tracking-tight md:text-xl">{t}</p>
      <p className="text-muted-foreground m-0 text-sm leading-relaxed whitespace-pre-wrap md:text-[0.9375rem]">
        {d}
      </p>
    </aside>
  )
}
